import N2StylesModal from '../components/N2StylesModal'

export default class AdDesignJobsJobFeedback {
  constructor(params) {
    this.params = params;
  }

  new() {
    new N2StylesModal('#js-ad-design-feedback')

    N2.handle('click', '#give-job-feedback-button', (e) => {
      this.feedbackForm = new N2Styles.manualForm(this.feedbackUrl());
      $('#job-feedback-first-screen').addClass("hidden");
      $('#job-feedback-second-screen').removeClass("hidden");
    })

    N2.handle('click', '#design-quality-buttons', (e) => {
      $('#job-feedback-second-screen').addClass("hidden");
      $('#job-feedback-third-screen').removeClass("hidden");
    })

    N2.handle('click', '.design-quality-emoji', (e) => {
      let quality = $(e.currentTarget).data("value");
      this.feedbackForm.addInput('job_feedback[quality]', quality);
    })

    N2.handle('click', '.design-interaction-emoji', (e) => {
      let interaction = $(e.currentTarget).data("value");
      this.feedbackForm.addInput('job_feedback[interaction]', interaction);
      this.feedbackForm.post();
    })
  }

  feedbackUrl() {
    return `/ad_design_jobs/${this.params.adDesignJobId}/job_feedback`;
  }
}
